// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useRequest } from "redux-query-react";
import { useSelector } from 'react-redux';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { AssetFromJSON, } from '../models';
/**
 * Get asset by id
 * Get asset by id
 */
export function getAssetByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getAssetById.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/asset/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            Asset: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = AssetFromJSON(body);
            let key = "";
            if (requestParameters.id) {
                key = `${key}${requestParameters.id}`;
            }
            return { Asset: { [key]: objResponse } };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetAssetById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get asset by id
* Get asset by id
*/
/**
 * Use this selector to get a reference to a single Asset matching the id
 * @param id Id of the Asset
 * @returns The Asset object
 */
export const useAssetByIdSelector = (id) => {
    let key = "";
    if (id) {
        key = `${key}${id}`;
    }
    return useSelector((state) => state.entities.Asset[key], isEqual);
};
/**
 * Request hook for a single Asset. Beware, this should not be called without a valid id ***WIP***
 * @param id id of the Asset
 * @returns an array containing the data, query state, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetAssetById = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getAssetByIdRaw(requestParameters, customQueryConfig));
    return [
        useAssetByIdSelector(requestParameters.id),
        querystate,
        forceRefresh
    ];
};
export function getAssetById(requestParameters, requestConfig) {
    return getAssetByIdRaw(requestParameters, requestConfig);
}
